const _calculatePaidAmount = {
  methods: {
    _calculatePaidAmount (screener) {
      var paid_amount = 0;

      if (!screener || !screener.payment_charges) {
        return paid_amount;
      }
      var paymentCharges = screener.payment_charges;
      for (const key in paymentCharges) {
        // Screener payment charges may contain other charges too
        if (
          key.includes ('participant_slot') &&
          paymentCharges.hasOwnProperty (key)
        ) {
          const participant_slot = paymentCharges[key];
          if (participant_slot.is_paid) {
            paid_amount += participant_slot.amount;
          }
        }
      }
      return paid_amount;
    },
  },
};

const _calculateTotalBudget = {
  methods: {
    _calculateTotalBudget (screener) {
      var total_amount = 0;

      if (!screener || !screener.payment_charges) {
        return total_amount;
      }
      var paymentCharges = screener.payment_charges;
      for (const key in paymentCharges) {
        // Screener payment charges may contain other charges too
        if (
          key.includes ('participant_slot') &&
          paymentCharges.hasOwnProperty (key)
        ) {
          const participant_slot = paymentCharges[key];
          total_amount += participant_slot.amount;
        }
      }
      return total_amount;
    },
  },
};

export {_calculatePaidAmount, _calculateTotalBudget};
